var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5101 4.1665H6.66536C6.20513 4.1665 5.83203 4.5396 5.83203 4.99983V44.1665C5.83203 44.6267 6.20513 44.9998 6.66536 44.9998H33.7487H35.832C36.2923 44.9998 36.6654 44.6267 36.6654 44.1665V13.34C36.6654 13.1193 36.5778 12.9076 36.4219 12.7514L28.1 4.41123C27.9437 4.25455 27.7315 4.1665 27.5101 4.1665Z",
    stroke: "#3A7BFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 35H27.4987",
    stroke: "#3A7BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 27.4585C15 24.3335 20 21.2085 21.25 17.4585",
    stroke: "#3A7BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 19.9585C15.625 19.9585 17.5 23.7085 20.625 24.9585M12.5 15.8335H25M18.75 15.8335V13.3335M23.125 28.7085L24.0175 26.2085M24.0175 26.2085L26.145 20.2522C26.1759 20.1663 26.2326 20.092 26.3074 20.0395C26.3821 19.987 26.4712 19.9589 26.5625 19.9589C26.6538 19.9589 26.7429 19.987 26.8176 20.0395C26.8924 20.092 26.9491 20.1663 26.98 20.2522L29.1075 26.2085M24.0175 26.2085H29.1075M29.1075 26.2085L30 28.7085",
    stroke: "#3A7BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.67e94b6842943f2850477ba19a6453c7.svg";
export { ForwardRef as ReactComponent };